<template>
  <v-container fluid class="py-0" grid-list-md>
    <v-row justify="center">
      <v-col cols="12" md="9" mx-auto>
        <v-card flat v-if="lAction === 'view'">
          <v-card-text class="py-3 px-0">
            <v-layout>
              <v-flex xs12>
                <v-data-table
                :headers="serviceHeader" 
                :items="servicesList"
                hide-default-footer
                disable-pagination
                :mobile-breakpoint="0"
                class="elevation-3">
                <template slot="item" slot-scope="props">
                  <tr @click="prepareEditService(props.item)">
                    <td>{{ props.item.service_name }}</td>
                    <td>{{ props.item.service_desc }}</td>
                    <td>{{ props.item.is_taxable ? 'Yes' : 'No' }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-btn
      :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
      dark fab fixed color="accent" v-if="lAction === 'view'"
      @click.native="prepareCreate">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height>
      <v-layout row wrap>
        <v-flex xs12 mx-auto>
          <v-form ref="dForm" @submit.prevent="saveChanges(lAction)">
            <v-card flat>
              <v-card-title class="title">
                {{ handy.startWithUpper(lAction) + ' Service' }}
              </v-card-title>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                    v-model="lService.service_name"
                    label="Service Name"
                    :rules="[rules.required]"
                    hide-details
                    maxlength="50"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                    v-model="lService.service_desc"
                    label="Description"
                    hide-details
                    maxlength="100"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-checkbox
                    v-model="lService.is_taxable"
                    label="Taxable"
                    hide-details
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-btn v-if="lAction === 'update'" @click="deleteService(lService)">delete</v-btn>
                <v-spacer></v-spacer>
                <v-btn @click.stop="lAction = 'view'">Cancel</v-btn>
                <v-btn type="submit" color="accent" :disabled="beingSaved">save</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- snack bar for reporting -->
    <v-snackbar :color="sbarCol" v-model="sbar"
    :timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
  </v-snackbar>
</v-col>
</v-row>
</v-container>
</template>


<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
export default {
  data () {
    return {
      lAction: '',
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      handy: handy,
      rules: handy.rules,
      beingSaved: false,
      serviceHeader: [
        { text: 'Service Name', value: 'service_name' },
        { text: 'Description', value: 'service_desc' },
        { text: 'Is Taxable?', value: 'is_taxable' }
      ],
      servicesList: []
    }
  },
  mounted () {
    this.lAction = 'view'
    this.loadServices()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadServices () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getSubServicesByVendorId/', qry)
      .then(response => {
        this.servicesList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    getEmptyService () {
      var emptyService = {
        service_name: '',
        service_desc: '',
        is_taxable: '',
        vendor_id: config.VENDOR_ID
      }
      return emptyService
    },
    prepareCreate () {
      this.lService = this.getEmptyService()
      this.lAction = 'create'
    },
    saveChanges (action) {
      // validate and save Changes
      if (this.$refs.dForm.validate()) {
        this.beingSaved = true
        this.axios.post(config.API_URL + '/service/' + action, this.lService)
        .then(response => {
          // refresh the Employee Designation list
          this.lService.service_id = response.data
          if (action === 'update') {
            var idx = this.servicesList.findIndex(obj => obj.service_id === this.lService.service_id)
            Object.assign(this.servicesList[idx], this.lService)
          } else {
            this.servicesList.push(this.lService)
          }
          this.lAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }
    },
    prepareEditService (curService) {
      this.lService = Object.assign({}, curService)
      this.lAction = 'update'
    },
    deleteService (curService) {
      if (!confirm('Sure, you want to delete the Service with name "' + curService.service_name + '"?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/service/delete', curService)
       .then(response => {
        var idx = this.servicesList.findIndex(obj => obj.service_id === this.lService.service_id)
        this.servicesList.splice(idx, 1)
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    }
  }
}
</script>
